import {Col, Icon, Row, Tooltip} from 'antd'
import autobind from 'autobind-decorator'
import * as React from 'react'
import {withTranslation, WithTranslation} from 'react-i18next'
import {connect} from 'redux-scaffolding-ts'
import {ItemReference, QueryResult} from 'src/core/stores/dataStore'
import {RestrictionPlansStore} from 'src/stores/restriction-plans-store'
import SelectionInput from '../core/ui/form/selectionInput'

interface RestrictionPlanEditorProps extends WithTranslation {
    value?: string
    companyId: string
    disabled?: boolean
    onChange?: (value: number) => void
    placeholder?: string
    filter?: {}
    emptySign?: string,
}

interface RestrictionPlanEditorState {
    planId: string | undefined,
    empty: boolean,
}

@connect(['dropdownrestrictionplans', RestrictionPlansStore])
class RestrictionPlanEditor extends React.Component<
RestrictionPlanEditorProps,
RestrictionPlanEditorState
> {
    private get restrictionPlansStore() {
        return (this.props as any).dropdownrestrictionplans as RestrictionPlansStore
    }

    constructor(props: RestrictionPlanEditorProps) {
        super(props)
        this.state = {
            planId: props.value,
            empty: false,
        }
        this.restrictionPlansStore.changeUrl(props.companyId)
    }

    static getDerivedStateFromProps(
        nextProps: RestrictionPlanEditorProps,
        prevState: RestrictionPlanEditorState
    ) {
        if (nextProps.value !== prevState.planId) {
            return { planId: nextProps.value }
        } else return null
    }

    @autobind
    componentDidMount() {
        this.getRestrictionPlans('')
    }

    @autobind
    private async handleChange(item: any) {
        if (this.props.onChange) {
            this.props.onChange(item && item.id ? item.id : (item as any) || undefined)
        }
    }

    @autobind
    private async getRestrictionPlans(searchQuery: string): Promise<QueryResult<ItemReference>> {
        var result = (await this.restrictionPlansStore.getAllAsync({
            searchQuery: searchQuery,
            skip: 0,
            parameters: {
                includeIds: this.props.value
            },
            take: 25,
            filter: this.props.filter,
            orderBy: [{ field: 'displayName', direction: 'Ascending', useProfile: true }]
        })) || { count: 0, items: [] }
        this.setState({ empty: result.count === 0 })
        return {
            count: result.count,
            items: result.items.map(
                o =>
                    ({
                        id: `${o.id}`,
                        title: `${o.displayName}`
                    } as ItemReference)
            )
        } as QueryResult<ItemReference>
    }

    public render() {
        return (
            <Row gutter={24}>
                <Col span={20}>
                <SelectionInput
                    content={o => (
                        <div>
                            <Icon type="schedule" />
                            <span>&nbsp;{o ? o.title : ''}</span>
                        </div>
                    )}
                    disabled={this.props.disabled}
                    placeholder={this.props.placeholder}
                    query={this.getRestrictionPlans}
                    value={this.state.planId as any}
                    onChange={this.handleChange}
                    showFooter
                    searchable
                    nullable
                    />
                </Col>
                <Col span={1}>
                    {this.state.empty && this.props.emptySign &&
                        <Tooltip title={this.props.emptySign}>
                            <Icon type="info-circle" style={{ fontSize: '12px', color: 'orange' }} />
                        </Tooltip>
                    }
                </Col>
            </Row>
        )
    }
}

export default withTranslation()(RestrictionPlanEditor)
